import { QuickTable, QuickTableFilterTabs } from "../../components";
import { teamAndSecurityDisplayFormatter } from "./teamAndSecurityDisplayFormatter";
import { Route, Routes } from "react-router-dom";
import { InviteTeamMemberForm } from "./InviteTeamMemberForm/InviteTeamMemberForm";
import { ITeamAndSecurityViewProps } from "./TeamAndSecurity";
import { AcceptTeamInvitation } from "../AcceptTeamInvitation";
import { ManageTeamMember } from "./ManageTeamMember";

// import linkColoredIcon from "../../assets/icons/link-colored.svg";

export const View = (props: ITeamAndSecurityViewProps) => {
  return (
    <div className="team-and-security-page">
      {/* <PageBanner
        iconSource={linkColoredIcon}
        pageTitle={"Manage your team for "}
        pageSubtitle={
          "Products are items or services you sell to your customers"
        }
        pageDescription={
          "Create a product or service, create a payment link, send link to your customers, and receive payments securely."
        }
        linkTitle={"Create payment links for your products"}
        linkSubtitle={"Create a custom payment page and share a link to it.."}
      /> */}

      <QuickTable
        id="teamAndSecurityTable"
        data={props.data}
        headers={props.headers}
        isLoading={props.isLoading}
        isError={props.isError}
        itemCount={props.totalCount}
        // renderDetail={(item) => item.product_description}
        toolbarTabs={
          <QuickTableFilterTabs
            queryStringTabNavLinks={props.queryStringTabs}
          />
        }
        displayFormatter={teamAndSecurityDisplayFormatter}
        onExport={props.onExport}
        openCreateNewModal={props.openCreateNewModal}
        createNewButtonText="Invite Team Member"
        openDetailsModal={props.openDetailsModal}
        disableClickOnTargetClassNames={["copy-btn"]}
      />

      <Routes>
        <Route
          path="invite-team-member"
          element={<InviteTeamMemberForm refreshTable={props.refreshTable} />}
        />

        {/* <Route path=":id/details" element={<TeamMemberDetails />} /> */}
        <Route
          path=":id/details"
          element={<ManageTeamMember refreshTable={props.refreshTable} />}
        />
      </Routes>
    </div>
  );
};
